import { formatISOToPHT } from './date';

function isDifferentFunction(oldData, newData) {
  const normalize = (value) => {
    if (value === null || value === undefined) return '';
    return String(value); // converts number, boolean, etc. to string
  };

  const oldValue = normalize(oldData);
  const newValue = normalize(newData);

  return oldValue !== newValue;
}

export function getComparisonSections(
  editRequest,
  currEmployee,
  currEmpAddress,
  currEmpRelations,
  currEmpEducation,
  currEmpCivService,
  currEmpWorkExp,
  currEmpCivicWork,
  currEmpTraining,
  currEmpHistory
) {
  const basicInfo = editRequest.proposeddata.basicinfo;
  const personalInfo = editRequest.proposeddata.personalinfo;
  const empAddress = editRequest.proposeddata.empaddress;
  const empRelations = editRequest.proposeddata.emprelations;
  const empEducation = editRequest.proposeddata.empeducation;
  const empCivService = editRequest.proposeddata.empcivservice;
  const empWorkExp = editRequest.proposeddata.empworkexp;
  const empCivicWork = editRequest.proposeddata.empcivicwork;
  const empTraining = editRequest.proposeddata.emptraining;
  const empHistory = editRequest.proposeddata.emphistory;

  const sections = {
    basicinfo: [
      {
        label: 'First Name',
        original: currEmployee.firstname,
        proposed: basicInfo.firstname,
        isdifferent: isDifferentFunction(
          currEmployee.firstname,
          basicInfo.firstname
        ),
      },
      {
        label: 'Last Name',
        original: currEmployee.lastname,
        proposed: basicInfo.lastname,
        isdifferent: isDifferentFunction(
          currEmployee.lastname,
          basicInfo.lastname
        ),
      },
      {
        label: 'Middle Name',
        original: currEmployee.middlename,
        proposed: basicInfo.middlename,
        isdifferent: isDifferentFunction(
          currEmployee.middlename,
          basicInfo.middlename
        ),
      },
      {
        label: 'Email',
        original: currEmployee.email,
        proposed: basicInfo.email,
        isdifferent: isDifferentFunction(currEmployee.email, basicInfo.email),
      },
    ],
    personalinfo: [
      {
        label: 'Nickname',
        original: currEmployee.nickname,
        proposed: personalInfo.nickname,
        isdifferent: isDifferentFunction(
          currEmployee.nickname,
          personalInfo.nickname
        ),
      },
      {
        label: 'Age',
        original: currEmployee.age,
        proposed: personalInfo.age,
        isdifferent: isDifferentFunction(currEmployee.age, personalInfo.age),
      },
      {
        label: 'Sex',
        original: currEmployee.sex,
        proposed: personalInfo.sex,
        isdifferent: isDifferentFunction(currEmployee.sex, personalInfo.sex),
      },
      {
        label: 'Date of Birth',
        original: formatISOToPHT(currEmployee.dateofbirth),
        proposed: formatISOToPHT(personalInfo.dateofbirth),
        isdifferent: isDifferentFunction(
          formatISOToPHT(currEmployee.dateofbirth),
          formatISOToPHT(personalInfo.dateofbirth)
        ),
      },
      {
        label: 'Place of Birth',
        original: currEmployee.placeofbirth,
        proposed: personalInfo.placeofbirth,
        isdifferent: isDifferentFunction(
          currEmployee.placeofbirth,
          personalInfo.placeofbirth
        ),
      },
      {
        label: 'Blood Type',
        original: currEmployee.bloodtype,
        proposed: personalInfo.bloodtype,
        isdifferent: isDifferentFunction(
          currEmployee.bloodtype,
          personalInfo.bloodtype
        ),
      },
      {
        label: 'Civil Status',
        original: currEmployee.civilstatus,
        proposed: personalInfo.civilstatus,
        isdifferent: isDifferentFunction(
          currEmployee.civilstatus,
          personalInfo.civilstatus
        ),
      },
      {
        label: 'Citizenship',
        original: currEmployee.citizenship,
        proposed: personalInfo.citizenship,
        isdifferent: isDifferentFunction(
          currEmployee.citizenship,
          personalInfo.citizenship
        ),
      },
      {
        label: 'Height',
        original: currEmployee.height,
        proposed: personalInfo.height,
        isdifferent: isDifferentFunction(
          currEmployee.height,
          personalInfo.height
        ),
      },
      {
        label: 'Weight',
        original: currEmployee.weight,
        proposed: personalInfo.weight,
        isdifferent: isDifferentFunction(
          currEmployee.weight,
          personalInfo.weight
        ),
      },
      {
        label: 'Cellphone Number',
        original: currEmployee.cellphone,
        proposed: personalInfo.cellphone,
        isdifferent: isDifferentFunction(
          currEmployee.cellphone,
          personalInfo.cellphone
        ),
      },
      {
        label: 'Passport',
        original: currEmployee.passport,
        proposed: personalInfo.passport,
        isdifferent: isDifferentFunction(
          currEmployee.passport,
          personalInfo.passport
        ),
      },
      {
        label: 'SSS',
        original: currEmployee.sss,
        proposed: personalInfo.sss,
        isdifferent: isDifferentFunction(currEmployee.sss, personalInfo.sss),
      },
      {
        label: 'Pag-IBIG',
        original: currEmployee.pagibig,
        proposed: personalInfo.pagibig,
        isdifferent: isDifferentFunction(
          currEmployee.pagibig,
          personalInfo.pagibig
        ),
      },
      {
        label: 'PhilHealth',
        original: currEmployee.philhealth,
        proposed: personalInfo.philhealth,
        isdifferent: isDifferentFunction(
          currEmployee.philhealth,
          personalInfo.philhealth
        ),
      },
      {
        label: 'GSIS',
        original: currEmployee.gsis,
        proposed: personalInfo.gsis,
        isdifferent: isDifferentFunction(currEmployee.gsis, personalInfo.gsis),
      },
      {
        label: 'TIN',
        original: currEmployee.tin,
        proposed: personalInfo.tin,
        isdifferent: isDifferentFunction(currEmployee.tin, personalInfo.tin),
      },
      {
        label: 'Skills',
        original: currEmployee.skills,
        proposed: personalInfo.skills,
        isdifferent: isDifferentFunction(
          currEmployee.skills,
          personalInfo.skills
        ),
      },
      {
        label: 'Hobbies',
        original: currEmployee.hobbies,
        proposed: personalInfo.hobbies,
        isdifferent: isDifferentFunction(
          currEmployee.hobbies,
          personalInfo.hobbies
        ),
      },
    ],
    empaddress: {
      old: currEmpAddress,
      new: empAddress,
    },
    emprelations: {
      old: currEmpRelations,
      new: empRelations,
    },
    empeducation: {
      old: currEmpEducation,
      new: empEducation,
    },
    empcivservice: {
      old: currEmpCivService,
      new: empCivService,
    },
    empworkexp: {
      old: currEmpWorkExp,
      new: empWorkExp,
    },
    empcivicwork: {
      old: currEmpCivicWork,
      new: empCivicWork,
    },
    emptraining: {
      old: currEmpTraining,
      new: empTraining,
    },
    emphistory: [
      {
        label: 'Formally Charged',
        original: currEmpHistory.formallycharged ? 'True' : 'False',
        proposed: empHistory.formallycharged ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.formallycharged ? 'True' : 'False',
          empHistory.formallycharged ? 'True' : 'False'
        ),
      },
      {
        label: 'Charge Details',
        original: currEmpHistory.chargedetails,
        proposed: empHistory.chargedetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.chargedetails,
          empHistory.chargedetails
        ),
      },
      {
        label: 'Guilty Offense',
        original: currEmpHistory.guiltyoffense ? 'True' : 'False',
        proposed: empHistory.guiltyoffense ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.guiltyoffense ? 'True' : 'False',
          empHistory.guiltyoffense ? 'True' : 'False'
        ),
      },
      {
        label: 'Offense Details',
        original: currEmpHistory.offensedetails,
        proposed: empHistory.offensedetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.offensedetails,
          empHistory.offensedetails
        ),
      },
      {
        label: 'Convicted',
        original: currEmpHistory.convicted ? 'True' : 'False',
        proposed: empHistory.convicted ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.convicted ? 'True' : 'False',
          empHistory.convicted ? 'True' : 'False'
        ),
      },
      {
        label: 'Convict Details',
        original: currEmpHistory.convictdetails,
        proposed: empHistory.convictdetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.convictdetails,
          empHistory.convictdetails
        ),
      },
      {
        label: 'Terminated Employment',
        original: currEmpHistory.terminatedemployment ? 'True' : 'False',
        proposed: empHistory.terminatedemployment ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.terminatedemployment ? 'True' : 'False',
          empHistory.terminatedemployment ? 'True' : 'False'
        ),
      },
      {
        label: 'Employment Details',
        original: currEmpHistory.employmentdetails,
        proposed: empHistory.employmentdetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.employmentdetails,
          empHistory.employmentdetails
        ),
      },
      {
        label: 'Indigenous Member',
        original: currEmpHistory.indigenousmember ? 'True' : 'False',
        proposed: empHistory.indigenousmember ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.indigenousmember ? 'True' : 'False',
          empHistory.indigenousmember ? 'True' : 'False'
        ),
      },
      {
        label: 'Indigenous Details',
        original: currEmpHistory.indigenousdetails,
        proposed: empHistory.indigenousdetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.indigenousdetails,
          empHistory.indigenousdetails
        ),
      },
      {
        label: 'Differently Abled',
        original: currEmpHistory.diffabled ? 'True' : 'False',
        proposed: empHistory.diffabled ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.diffabled ? 'True' : 'False',
          empHistory.diffabled ? 'True' : 'False'
        ),
      },
      {
        label: 'Differently Abled Details',
        original: currEmpHistory.diffableddetails,
        proposed: empHistory.diffableddetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.diffableddetails,
          empHistory.diffableddetails
        ),
      },
      {
        label: 'Solo Parent',
        original: currEmpHistory.soloparent ? 'True' : 'False',
        proposed: empHistory.soloparent ? 'True' : 'False',
        isdifferent: isDifferentFunction(
          currEmpHistory.soloparent ? 'True' : 'False',
          empHistory.soloparent ? 'True' : 'False'
        ),
      },
      {
        label: 'Solo Parent Details',
        original: currEmpHistory.soloparentdetails,
        proposed: empHistory.soloparentdetails,
        isdifferent: isDifferentFunction(
          currEmpHistory.soloparentdetails,
          empHistory.soloparentdetails
        ),
      },
    ],
  };

  return sections;
}
